import { postServiceCall, getServiceCall, deleteServiceCall } from "./base";
import {
  VendingConfig,
  VendingResponse,
  VendingSaveResponse,
  BranchLogoUrl,
  BranchLogoData,
  BranchLanguageData,
  StatisticData,
  BranchLogoDelete,
  ForceConfigPricesData,
  VendingTopayMessagesResponse,
  VendingAllTopayMessagesResponse,
  BranchLanguageSave,
  CountByCategory,
  RemoteCommandRequest,
  VendingConfigOptions
} from "../api";
import store from "../store";

export async function getVendingOptions(): Promise<VendingConfigOptions> {
  return await getServiceCall(`vending/getConfigOptions?language=${store.state.lang.key}`);
}

export async function getVendingConfig(tcod: string): Promise<VendingResponse> {
  return await getServiceCall(`vending/get?tcod=${tcod}&language=${store.state.lang.key}`);
}

export async function saveVendingConfig(data: VendingConfig): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/save", { ...data, language: store.state.lang.key });
}

export async function getVendingBranchData(branchID: number): Promise<BranchLogoUrl> {
  return await getServiceCall(`vending/getBranchData?branchID=${branchID}&language=${store.state.lang.key}`);
}

export async function getVendingLanguageData(branchID: number): Promise<BranchLanguageData> {
  return await getServiceCall(`vending/getBranchLanguageData?branchID=${branchID}&language=${store.state.lang.key}`);
}

export async function saveVendingBranchData(data: BranchLogoData): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/saveBranchData", { ...data, language: store.state.lang.key });
}

export async function deleteVendingBranchData(data: BranchLogoDelete): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/saveBranchData", { ...data, language: store.state.lang.key });
}

export async function saveVendingBranchLanguageData(data: BranchLanguageSave): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/saveBranchLanguageData", { ...data });
}

export async function saveBranchVendorData(data: BranchLogoData): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/saveBranchVendorData", { ...data, language: store.state.lang.key });
}

export async function deleteTopayMessage(id: string, tcod: string): Promise<VendingSaveResponse> {
  return await deleteServiceCall(`vending/deleteTopayMessage?id=${id}&tcod=${tcod}&language=${store.state.lang.key}`);
}

export async function queryTopayMessages(tcod: string, page: number): Promise<VendingTopayMessagesResponse> {
  return await getServiceCall(`vending/queryTopayMessages?tcod=${tcod}&page=${page}`);
}

export async function queryAllTopayMessages(): Promise<VendingAllTopayMessagesResponse> {
  return await getServiceCall("vending/queryAllTopayMessages");
}

export async function executeCommand(data: RemoteCommandRequest): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/executeCommand", { ...data, language: store.state.lang.key });
}

export async function executeForceConfigPrices(data: ForceConfigPricesData): Promise<VendingSaveResponse> {
  return await postServiceCall("vending/forceConfigPrices", { ...data, language: store.state.lang.key });
}

export async function getVendingStatisticsSummary(tcod: string, from: string, to: string): Promise<CountByCategory> {
  return await getServiceCall(`vending/statistics?tcod=${tcod}&category=&from=${from}&to=${to}`);
}

export async function getVendingStatisticsData(
  tcod: string,
  category: string,
  from: string,
  to: string
): Promise<StatisticData[]> {
  return await getServiceCall(`vending/statistics?tcod=${tcod}&category=${category}&from=${from}&to=${to}`);
}
